/**
 * 消息提示
 */
import messagerPc from './messagerPc'
import messagerMobile from  './messagerMobile'
let messager = null;
//判断是否为手机端或者是pc端引用不同的ui组件
if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    messager =messagerMobile;
} else {
    messager = messagerPc;
}
export default messager;
